<template>
<div class="chapter">
<div class="inner_page">
<p class="p0"><span class="t2">Working Men Volume 1</span></p>
<p class="p0">Gay Erotic Romance Box Set</p>
<p class="p0">12 Stories in 1 Collection!</p>
<p class="p0">By J.M. Snyder</p>
<p class="p0"><span class="t6">TABLE OF CONTENTS:</span></p>
<p class="p2"><a id="a5"></a><a href="#/005#a20">At Your Service</a></p>
<p class="p2"><a href="#/006#a21">Café de l’Amour</a></p>
<p class="p2"><span href="#/007#a22" title="Link target outside of Sample">Car Trouble</span></p>
<p class="p2"><span href="#/008#a23" title="Link target outside of Sample">Closing Time</span></p>
<p class="p2"><span href="#/009#a24" title="Link target outside of Sample">Easily Addicted</span></p>
<p class="p2"><span href="#/010#a25" title="Link target outside of Sample">Lunch Break</span></p>
<p class="p2"><span href="#/011#a26" title="Link target outside of Sample">Makin’ Copies</span></p>
<p class="p2"><span href="#/012#a27" title="Link target outside of Sample">On the Job</span></p>
<p class="p2"><span href="#/013#a28" title="Link target outside of Sample">Opening Day at the County Fair</span></p>
<p class="p2"><span href="#/014#a29" title="Link target outside of Sample">Order Up</span></p>
<p class="p2"><span href="#/015#a30" title="Link target outside of Sample">Pleasure Cruise</span></p>
<p class="p2"><span href="#/016#a31" title="Link target outside of Sample">Speed Trap</span></p>
<p class="p2"><span href="#/017#a32" title="Link target outside of Sample">Summer Kisses and Ice Cream Dreams</span></p>
<p class="p2"><span href="#/018#a33" title="Link target outside of Sample">Tech Support</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 004.vue?33e591c0